import { Typography } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { Colors } from '../style/theme';

const FooterTitle = ({ text }) => (
  <Typography
    sx={{
      color: Colors.white,
      fontWeight: '700',
      textTransform: 'capitalize',
      pb: 1,
      fontSize:'1.10rem'
    }}
  >
    {text}
  </Typography>
);
FooterTitle.propTypes = {
  text: PropTypes.string,
};
export default FooterTitle;
